import React, {useCallback, useRef} from 'react';
import {useParams} from 'react-router';

import useUserMessages from './hooks';
import ChatForm from 'modules/chatForm';

const ChatFormContainer = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const {chatId} = useParams();
  const {messages, isRoomLoading, refetch, fetchNextPage} =
    useUserMessages(chatId);

  const onWatchEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  return (
    <div className="h-full" ref={wrapperRef}>
      <ChatForm
        isScrollLoading={isRoomLoading}
        onWatchEnd={onWatchEnd}
        refresh={refetch}
        elements={messages?.pages.flatMap(x => x.results) || []}
        chatId={chatId}
      />
    </div>
  );
};

export default ChatFormContainer;
